export default {
  title: 'Plătește cu {{method}}',
  hint: 'În continuare, confirmi plata prin banca ta sau în aplicație.',
  continue: 'Continuă',
  cancel: 'Anulează plata',
  unavailable: 'Această metodă de plată nu este disponibilă momentan. Alege alta.',
};
